module.exports = __webpack_public_path__ + "img/Kollektionen_Hintergrund.f3e80f2e.jpg";